import { useMutation } from '@tanstack/react-query';
import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDeleteUser = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id: number) =>
    usersRepo.deleteUser(id),
  );
